export const Top1Filled = () => {
    return (
        <svg width="189" height="140" viewBox="0 0 189 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M48.7937 138.761L64.5752 32.7774L36.0266 44.1458L40.2823 15.1745L73.0865 1.23894H98.9753L78.5834 138.761H48.7937Z"
                fill="#1D252D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M72.8499 0H100.371L79.6117 140H47.3968L63.0762 34.7018L34.5322 46.0685L39.1995 14.295L72.8499 0ZM73.3229 2.47788L41.3648 16.054L37.5208 42.2232L66.0738 30.8529L50.1903 137.522H77.5549L97.5793 2.47788H73.3229Z"
                fill="url(#paint0_linear_3611_2635)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3611_2635"
                    x1="60.5928"
                    y1="-45.8407"
                    x2="60.5928"
                    y2="193.274"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#3A4755" />
                </linearGradient>
            </defs>
        </svg>
    );
};
